export function toggle(className, selector, relatedTarget, closest, animated = false) {
    const toggleElements = document.querySelectorAll(selector);
    if (!toggleElements.length)
        return;
    toggleElements.forEach(toggleElement => {
        let relatedObjects = null;
        let closestElement = null;
        if (relatedTarget)
            relatedObjects = toggleElement.querySelectorAll(relatedTarget);
        if (closest)
            closestElement = toggleElement.closest(closest);
        toggleElement.addEventListener("click", (e) => {
            e.preventDefault();
            toggleElement.classList.toggle(className);
            relatedObjects && relatedObjects.forEach(relate => {
                relate.classList.toggle(className);
            });
            closestElement && closestElement.classList.toggle(className);
            if (animated) {
                const nextEl = toggleElement.nextElementSibling;
                (nextEl?.style.maxHeight)
                    ? nextEl.style.setProperty("max-height", null)
                    : nextEl.style.maxHeight = nextEl.scrollHeight + "px";
            }
        });
    });
}
